import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { catchError, of, tap } from 'rxjs';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { PresenceDTO } from 'src/app/modules/agenda/components/models/presence.model';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-activity-confirmation-form',
  templateUrl: './activity-confirmation-form.component.html',
  styleUrls: ['./activity-confirmation-form.component.css'],
})
export class ActivityConfirmationFormComponent implements OnInit {
  confirmationForm!: FormGroup;

  idActivity!: number;
  iuf!: string;
  filled: boolean = false;
  codeMatched: boolean = true;
  valideCode: string = '0000';

  isLoading: boolean = true;
  session: boolean = false;
  data: any;
  responseInfo: any;

  succes: boolean = false;
  error: boolean = false;
  alreadyConfirm: boolean = false;
  showSpinner = false;
  isSubmitting: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinnerService: SpinnerServiceService,

    private service: AuthService
  ) {
    this.idActivity = +this.route.snapshot.params['idActivity'];
    this.iuf = this.route.snapshot.params['iuf'];
  }
  ngOnInit(): void {
    // console.log("l'iuf et l'id :  de l'activite : ", this.iuf, this.idActivity);

    this.initForm();
    this.getData();
  }

  initForm() {
    this.confirmationForm = this.formBuilder.group({
      prenom: ['', Validators.required],
      nom: ['', Validators.required],
      email: ['', Validators.required],

      pin1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      pin2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      pin3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      pin4: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
    });
  }
  isFieldInvalid(controlName: string): boolean | null {
    const control = this.confirmationForm.get(controlName);
    return control && control.invalid && control.touched;
  }

  onSubmitForm() {
    this.isSubmitting = true;
    if (this.confirmationForm.valid) {
      this.filled = false;
      const formValue = this.confirmationForm.value;
      const code =
        +formValue['pin1'] +
        formValue['pin2'] +
        formValue['pin3'] +
        formValue['pin4'];
      console.log('Le code saisi: ', code);
      console.log('Le formulaire est valide : ', this.confirmationForm.value);
      if (code === this.valideCode) {
        this.codeMatched = true;
        console.log('matchded : ', this.codeMatched);
        this.setPresence(this.idActivity, this.iuf);
      } else {
        this.codeMatched = false;

        console.log('unMatchded : ', this.codeMatched);
      }
    } else {
      this.filled = true;

      console.log('Le formulaire est invalide : ', this.confirmationForm.value);
    }
  }

  // Getter pour récupérer le code final
  get codeFinal(): string {
    const f = this.confirmationForm.value;
    return `${f.pin1}${f.pin2}${f.pin3}${f.pin4}`;
  }

  autoFocus(event: any, next: string) {
    if (event.target.value && next) {
      const el = document.querySelector(
        `[formControlName="${next}"]`
      ) as HTMLElement;
      el?.focus();
    }
  }
  onlyNumber(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  getData() {
    this.spinnerService.showSpinner();
    this.service
      .checkJpoConfirmation(this.iuf, this.idActivity)
      .pipe(
        tap((response: CustomResponse) => {
          this.spinnerService.hideSpinner();
          this.responseInfo = response.object;
          if (response.status == 200) {
            if (this.responseInfo.present == true) {
              this.alreadyConfirm = true;
              this.isLoading = false;
              this.session = false;
            } else {
              this.isLoading = false;
              this.session = true;
              this.updateForm(response.object);
            }
          }
          if (response.status == 404) {
            this.error = true;
            this.session = false;
            this.isLoading = false;
          }
          console.log('Response : ', response);
        })
      )
      .subscribe();
  }

  updateForm(data: any) {
    this.confirmationForm.patchValue({
      prenom: data?.firstName,
      nom: data?.lastName,
      email: data?.email,
    });
    this.confirmationForm.controls['prenom'].disable();
    this.confirmationForm.controls['nom'].disable();
    this.confirmationForm.controls['email'].disable();
  }

  public setPresence(activity_id: any, iuf: string) {
    const presenceInfo = new PresenceDTO(iuf, 'Personnel JPO', activity_id);
    this.showSpinner = true;
    this.service
      .setParticipantPresence(presenceInfo)
      .pipe(
        tap((response) => {
          this.showSpinner = false;
          this.succes = true;
          this.isLoading = false;
          this.session = false;
        }),
        catchError((err) => {
          this.error = true;
          return of(null);
        })
      )
      .subscribe();
  }
}
